require("./brokerPensionPlanPeriodicalContribution.scss");
//@vendors
const React = require("react");
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const trim = require('lodash/string/trim');
//commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKTable } = require('commonsComponents/OKTable');
const { OKLink } = require('commonsComponents/OKLink');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { AccordionRow } = require('commonsComponents/accordionRow');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const OKTag = require('components/commons/OKTag/OKTag');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const BrokerThreeContainerSummary = require('components/broker/brokerThreeContainerSummary/brokerThreeContainerSummary');

// @actions
const BrokerPensionPlanPeriodicalContributionActions = require('actions/brokerPensionPlanPeriodicalContribution');
const brokerPensionPlanContributionActions = require('actions/brokerPensionPlanContribution');
const brokerStocksByTypeActions = require('actions/brokerStocksByType');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatWithoutRound } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
const IbanHelper = require('utilities/ibanHelper');
const { conditionalValueOrHyphen } = require('utilities/valueHelper');

// @constants
const {
    MYPROFILE_BROKER_PLANS_URL,
    MYPROFILE_BROKER_EXPLORE_PLANS_URL,
    MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_CANCEL_URL,
    PLANS_ACTIVE,
    PLANS_SUSPENDED,
    PLANS_CANCELED,
    DATE_FORMAT,
    HYPHEN,
    BROKER_PLAN_PERIODICAL_CONTRIBUTION_SEGUN_IPC,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_CONTRIBUTION_DEFAULT_LAST_DATE,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_CONTRIBUTION_NO_NEXT_DATE
} = require('constants/index');

class BrokerPensionPlanPeriodicalContribution extends React.Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.updateData = this.updateData.bind(this);
        this.state = {
            selected: 0
        };
    }

    UNSAFE_componentWillMount() {
        this.props.resetPeriodicalContribution();
        this.props.reset();
    }

    componentDidMount() {
        const { immBrokerMyInvestments } = this.props;
        if (!immBrokerMyInvestments.get('fetchSuccess') && !immBrokerMyInvestments.get('isFetching') && !immBrokerMyInvestments.get('errorReceived')) {
            this.props.getStocksByType();
        }
    }

    handleToggleClick(index, producto, contrato, timeStamp, tipoApor, revalAnual) {
        const ignoreStored = true;
        if (this.state.selected !== index) {
            this.setState({ selected: index });
            this.props.getPeriodicalContributionDetails(producto, contrato, timeStamp, tipoApor, revalAnual, ignoreStored);
        } else {
            this.setState({ selected: -1 });
        }
    }

    getStatus(status) {
        switch (status) {
            case PLANS_ACTIVE:
                return formatText('pensionPlanPeriodicalContribution-statusActive');
            case PLANS_SUSPENDED:
                return formatText('pensionPlanPeriodicalContribution-statusSuspended');
            case PLANS_CANCELED:
                return formatText('pensionPlanPeriodicalContribution-statusCanceled');
        }
    }

    getInfoPlan(plan, product, contract, status) {
        let data =  {
            leftContainer: [],
            middleContainer: [],
            rightContainer: []
        };
        const planContractNumber =  IbanHelper.calculateContract(`${product}${contract}`);
        const formatContract = IbanHelper.formatAccountTextWithSpaces(planContractNumber, [4,4,3]);
        const holderPlan = plan.get('nombreTitular');
        const currentAccount = plan.getIn(['cuentaAsociada','codbban']);
        const formatCurrentAccount = IbanHelper.formatAccountTextWithSpaces(currentAccount, [4,4,2]);
        const dischargeDate = plan.get('fechaAlta');
        const lastContribution = plan.getIn(['planAportacion','fechaUltimaAportacion']);
        const formatLastContribution = conditionalValueOrHyphen(lastContribution !== BROKER_ORDERS_AND_MOVEMENTS_PLAN_CONTRIBUTION_DEFAULT_LAST_DATE,
            DateHelper.formatDate(lastContribution, DATE_FORMAT));
        const nextContribution = plan.getIn(['planAportacion','fechaProxAportacion']);
        const formatNextContribution = conditionalValueOrHyphen(nextContribution !== BROKER_ORDERS_AND_MOVEMENTS_PLAN_CONTRIBUTION_NO_NEXT_DATE,
            DateHelper.formatDate(nextContribution, DATE_FORMAT));
        const formatDischargeDate = DateHelper.formatDate(dischargeDate, DATE_FORMAT);
        data.leftContainer.push([formatText('pensionPlanPeriodicalContribution-planContractNumber'), formatContract]);
        data.leftContainer.push([formatText('pensionPlanPeriodicalContribution-holderPlan'), holderPlan]);
        data.leftContainer.push([formatText('pensionPlanPeriodicalContribution-currentAccount'), formatCurrentAccount]);
        data.middleContainer.push([formatText('pensionPlanPeriodicalContribution-dischargeDate'), formatDischargeDate]);
        if (status === PLANS_ACTIVE) {
            data.rightContainer.push([formatText('pensionPlanPeriodicalContribution-lastContribution'), formatLastContribution]);
            data.rightContainer.push([formatText('pensionPlanPeriodicalContribution-nextContribution'), formatNextContribution]);
        }
        if (status === PLANS_CANCELED) {
            data.middleContainer.push([formatText('pensionPlanPeriodicalContribution-lastContribution'), formatLastContribution]);
        }
        return data;
    }

    updateData(data) {
        const { immBrokerPensionPlanPeriodicalContribution } = this.props;
        const details = immBrokerPensionPlanPeriodicalContribution.getIn(['details','data']);
        const success = immBrokerPensionPlanPeriodicalContribution.getIn(['details','success']);
        const revalorizacion = trim(details.get('revalorizacion')).toUpperCase();
        let formatDatoRev = details.get('datoRev');
        if (revalorizacion === BROKER_PLAN_PERIODICAL_CONTRIBUTION_SEGUN_IPC) {
            data.middleContainer.push([
                formatText('pensionPlanPeriodicalContribution-annualRevaluation'),
                formatText('pensionPlanPeriodicalContribution-ipcOptionLabel'),
                ''
            ]);
        } else {
            if (formatDatoRev !== 0 && formatDatoRev !== 100) {
                formatDatoRev = formatDatoRev !== "" ? formatWithoutRound(formatDatoRev, 2) : HYPHEN;
            }

            if(success) {
                data.middleContainer.push([formatText('pensionPlanPeriodicalContribution-annualRevaluation'), formatDatoRev, "%"]);
            } else {
                data.middleContainer.push([formatText('pensionPlanPeriodicalContribution-annualRevaluation'),
                formatText('pensionPlanPeriodicalContribution-annualRevaluationNotAvailable')]);
            }

        }

        return data;
    }

    getCustomInstitutionSecurityId( productNumber, contractNumber) {
        const { immBrokerMyInvestments } = this.props;
        const immStocksByType = immBrokerMyInvestments.get('products');
        const plans = immStocksByType.getIn(['plans', 'stocks']);
        const plan = plans.find(
            immPlan => immPlan.get('numerodecontrato') === contractNumber && immPlan.get('producto') === productNumber
        );

        if(plan) {
            return plan.get('customInstitutionSecurityId');
        }

        return false;
    }

    shouldRenderOperarButton(status) {
        return status === PLANS_ACTIVE;
    }

    buildContentTable() {
        const { immBrokerPensionPlanPeriodicalContribution } = this.props;
        const periodicalContributionList = immBrokerPensionPlanPeriodicalContribution.get('periodicalContributionList');

        return periodicalContributionList.map((plan, index) => {
            const status = plan.getIn(['planAportacion','situacion']);
            const nombrePlan = plan.get('nombrePlan');
            const statusText = this.getStatus(status);
            const periodicity = plan.getIn(['planAportacion','periodicidad']);
            const importe = formatWithoutRound(plan.getIn(['planAportacion','importe']), 2);
            const divisa = plan.getIn(['planAportacion','divisa']);
            const value = `${importe} ${divisa}`;
            const product = plan.getIn(['contrato', 'producto']);
            const contract = plan.getIn(['contrato', 'numerodecontrato']);
            const timeStamp = plan.getIn(['planAportacion', 'timestampAlta']);
            const tipoApor = plan.getIn(['planAportacion', 'tipo']);
            const revalAnual = plan.getIn(['planAportacion', 'revalorizacionAnual']);
            let data = this.getInfoPlan(plan, product, contract, status);
            const customInstitutionSecurityId = this.getCustomInstitutionSecurityId(product, contract);

            const targetElement = (
                <OKButton
                    modifier="secondary"
                    size="small"
                    rightIcon="icon-dropdown-abrir"
                    smallRightIcon={true}
                    disabled={customInstitutionSecurityId === false}
                >
                    <FormattedText value="pensionPlanPeriodicalContribution-textButton" />
                </OKButton>
            );

            let items = [{
                visible: status === PLANS_ACTIVE,
                link: customInstitutionSecurityId ? `/myprofile/broker/pensionPlansPeriodicContribution/` + customInstitutionSecurityId + '/' + timeStamp : '',
                text: formatText('pensionPlanPeriodicalContribution-changeLinkLabel')
            },
            {
                visible: status === PLANS_ACTIVE,
                link: customInstitutionSecurityId ? MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_CANCEL_URL + '/' + customInstitutionSecurityId + '/' + timeStamp : '',
                text: formatText('common-cancel')
            }];

            const rowCells = [
                {
                    element: nombrePlan,
                    className: 'pension-plan-periodical-contribution__pension-plan'
                },
                {
                    element: (
                        <OKTag content={statusText} context="arrow"/>
                    ),
                    className: 'pension-plan-periodical-contribution__status'
                },
                {
                    element: periodicity.toLowerCase(),
                    className: 'pension-plan-periodical-contribution__periodicity'
                },
                /*{
                    element: "Date",
                    className: 'pension-plan-periodical-contribution__date'
                },*/
                {
                    element: value,
                    className: 'pension-plan-periodical-contribution__amount'
                }
            ];

            if (this.shouldRenderOperarButton(status)) {
                rowCells.push({
                    element: (
                        <PopoverMenu
                            target={targetElement}
                            items={items}
                            placement="bottomRight"
                        />
                    ),
                    className: 'pension-plan-periodical-contribution__button'
                });
            } else {
                rowCells.push({
                    element: '',
                    className: 'pension-plan-periodical-contribution__button'
                });
            }

            index++;
            const isFetching = immBrokerPensionPlanPeriodicalContribution.getIn(['details','isFetching']);
            let content;

            if (isFetching) {
                content = <LoadingSection />
            }
            else {
                data = this.updateData(data);
                content = (
                    <BrokerThreeContainerSummary
                        data={data}
                    />
                );
            }

            return (
                <AccordionRow
                    key={index}
                    index={index}
                    rowCells={rowCells}
                    onToggleClick={() => this.handleToggleClick(index, product, contract, timeStamp, tipoApor, revalAnual)}
                    visible={this.state.selected === index}
                >
                    <OKTableCell colSpan={6}>
                        {content}
                    </OKTableCell>
                </AccordionRow>
            );
        });
    }

    buildHeaderTable() {
        const pensionPlanCellTitle = formatText('pensionPlanPeriodicalContribution-pensionPlanCellTitle');
        const statusCellTitle = formatText('pensionPlanPeriodicalContribution-statusCellTitle');
        const periodicityCellTitle = formatText('pensionPlanPeriodicalContribution-periodicityCellTitle');
        //const dateCellTitle = formatText('pensionPlanPeriodicalContribution-dateCellTitle');
        const amountCellTitle = formatText('pensionPlanPeriodicalContribution-amountCellTitle');
        const contentBoxTitle = formatText('pensionPlanPeriodicalContribution-widgetPlansListTitle');
        const contentTable = this.buildContentTable();

        return (
            <ContentBox title={contentBoxTitle} titleSeparator={true} hasShadow={false} customClassName="pension-plan-periodical-contribution">
                <OKTable>
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell
                                asHeader={true}
                                className="pension-plan-periodical-contribution__toggle"
                            />
                            <OKTableCell
                                asHeader={true}
                                className="pension-plan-periodical-contribution__pension-plan"
                            >
                                {pensionPlanCellTitle}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="pension-plan-periodical-contribution__status"
                            >
                                {statusCellTitle}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="pension-plan-periodical-contribution__periodicity--header"
                            >
                                {periodicityCellTitle}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="pension-plan-periodical-contribution__amount"
                            >
                                {amountCellTitle}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="pension-plan-periodical-contribution__button"
                            >
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                    {contentTable}
                </OKTable>
            </ContentBox>
        );
    }

    buildSideColumn() {
        const titleSideColumn = formatText('pensionPlanPeriodicalContribution-titleSideColumn');
        const textSideColumn1 = (
            <div className="pension-plan-periodical-contribution__body-side-bar">
                <div className="pension-plan-periodical-contribution__info-icon">
                    <OKIconIllustrative icon="info" product="banking" />
                </div>
                <div className="pension-plan-periodical-contribution__info">
                    <div className="pension-plan-periodical-contribution__info-paragraph">
                        <FormattedText value="pensionPlanPeriodicalContribution-textSideColumn"/>
                    </div>
                </div>
            </div>
        );
        return (
            <ContactInfoBox boxTitle={titleSideColumn} boxBody={textSideColumn1}/>
        );
    }

    buildLinkBlock() {
        const { immBrokerPensionPlanPeriodicalContribution } = this.props;
        const hasPlans =  immBrokerPensionPlanPeriodicalContribution.get('hasPlans');
        const linkURL = hasPlans ? MYPROFILE_BROKER_PLANS_URL : MYPROFILE_BROKER_EXPLORE_PLANS_URL;

        return (
            <div className="pension-plan-periodical-contribution__empty-state-link" >
                <OKLink
                    to={linkURL} >
                    <FormattedText value="pensionPlanPeriodicalContribution-planLink" />
                </OKLink>
            </div>
        )
    }

    buildEmptyState() {
        const sideColumn = this.buildSideColumn();
        const linkBlock = this.buildLinkBlock();
        const errorMessage = (
            <div className="pension-plan-periodical-contribution__empty-state-msj">
                <div> { formatText('pensionPlanPeriodicalContribution-emptyStateMessage1') } </div>
                <div> { formatText('pensionPlanPeriodicalContribution-emptyStateMessage2') } </div>
            </div>
        );
        return (
            <section className="row grid-view--content-position-positive">
                <div className="col-xs-12 col-md-8">
                    <ContentBox customClassName="pension-plan-periodical-contribution__empty-state">
                        <EmptyState
                            secondaryText={errorMessage}
                            iconType="noitems-wealth" />
                        {linkBlock}
                    </ContentBox>
                </div>
                <div className="col-xs-12 col-md-4 grid-view--variable-cell-separation">
                    {sideColumn}
                </div>
            </section>
        );
    }
    render() {
        const { immBrokerPensionPlanPeriodicalContribution, immBrokerMyInvestments } = this.props;
        const isFetching = immBrokerPensionPlanPeriodicalContribution.get('isFetching');
        const success = immBrokerPensionPlanPeriodicalContribution.get('success');
        const isFetchingMyInvestments = immBrokerMyInvestments.get('isFetching');
        let content;
        if (isFetching || isFetchingMyInvestments) {
            content = <LoadingSection />
        }
        else if(success){
            const hasPlanPeriodicalContribution = immBrokerPensionPlanPeriodicalContribution.get('hasPeriodicalPlans');
            if (!hasPlanPeriodicalContribution) {
                content = this.buildEmptyState();
            }
            else {
                content = this.buildHeaderTable();
            }
        }
        return (
            <div>
                {content}
            </div>
        );
    }
}

BrokerPensionPlanPeriodicalContribution.propTypes = {
    immBrokerPensionPlanPeriodicalContribution: PropTypes.object.isRequired,
    getPeriodicalContributionDetails: PropTypes.func.isRequired,
    resetPeriodicalContribution: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired, //reset del header brokerPensionPlanContribution
    immBrokerMyInvestments: PropTypes.object.isRequired,
    getStocksByType: PropTypes.func.isRequired
};

module.exports = BrokerPensionPlanPeriodicalContribution;
module.exports.BrokerPensionPlanPeriodicalContribution = connect(
    state => ({
        immBrokerPensionPlanPeriodicalContribution: state.brokerPensionPlanPeriodicalContribution,
        immBrokerMyInvestments: state.brokerMyInvestments
    }),
    {
        getStocksByType: brokerStocksByTypeActions.getStocksByType,
        reset: brokerPensionPlanContributionActions.reset,
        getPeriodicalContributionDetails: BrokerPensionPlanPeriodicalContributionActions.getPeriodicalContributionDetails,
        resetPeriodicalContribution: BrokerPensionPlanPeriodicalContributionActions.resetPeriodicalContribution
    }
)(BrokerPensionPlanPeriodicalContribution);
